import type { FlightBase } from '@/types/flights';

export function flightTypeToDutch(flightType: FlightBase['type']): string {
  const translations = {
    outward: 'heenreis',
    return: 'terugreis',
    between: 'tussenvlucht',
  };
  return translations[flightType];
}
